import React, { useState } from "react";
import { config } from "../config";
import "./category.css";
import { useNavigate } from "react-router-dom";

const Category = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const [viewAllPopupVisible, setViewAllPopupVisible] = useState(false);
  const [popupaskque, setpopupaskque] = useState(false);
  const [buttonTexts, setButtonTexts] = useState([]);
  const [clickedImage, setClickedImage] = useState(null);

  const [textLine1, setTextLine1] = useState("");
  const [textLine2, setTextLine2] = useState("");
  const [TopicValue, setTopicValue] = useState("");
  const navigate = useNavigate();
  const handleButtonClick = (text, category) => {
    navigate("/create-academic", { state: { text, category } });
  };
  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);

  const handleImageClick = (imageId) => {
    const imageMappings = {
      button1: {
        text: "Copyright registrations",
        category: "Copyright registrations",
        url: "copyright-registrations-templates",
      },
      button2: {
        text: "Service contracts",
        category: "Service Contracts",
        url: "service-contracts",
      },
      button3: {
        text: "Last will and testament",
        category: "Last will and testament",
        url: "last-will-testament",
      },
      button4: {
        text: "Privacy policies",
        category: "Privacy Policies",
        url: "privacy-policies",
      },
      button5: {
        text: "Selling car",
        category: "Selling Car",
        url: "selling-car",
      },
      button6: {
        text: "Rental agreement",
        category: "Rental Agreement",
        url: "rental-agreement",
      },
      button7: {
        text: "Child custody",
        category: "Child Custody",
        url: "child-custody",
      },
      button8: {
        text: "Name change",
        category: "Name change",
        url: "name-change",
      },
      button9: {
        text: "Domestic parteners ship",
        category: "Domestic parteners ship",
        url: "domestic-parteners-ship",
      },
      button10: {
        text: "Real estate",
        category: "Real estate",
        url: "real-estate",
      },
      button11: {
        text: "Marriage certificate",
        category: "Marriage certificate",
        url: "marriage-certificate",
      },
      button12: {
        text: "Divorce",
        category: "Divorce",
        url: "Divorce",
      },
      button13: {
        text: "Lending Money",
        category: "Lending money",
        url: "lending-money",
      },
    };

    if (imageMappings[imageId]) {
      const { text, category, url } = imageMappings[imageId];

      navigate(`/${url}-templates`, {
        state: { text, category },
      });
    }
  };

  const handleAskQueClick = () => {
    setpopupaskque(true);
    setViewAllPopupVisible(false);
    setPopupVisible(false);
  };

  const closePopup = () => setPopupVisible(false);
  const closeViewAllPopup = () => setViewAllPopupVisible(false);
  const closepopupaskque = () => setpopupaskque(false);
  return (
    <div className="category_background">
      <div className="category_top">
        <div className="category_top_title">Category</div>
        <div className="view_all" onClick={() => setViewAllPopupVisible(true)}>
          View All
        </div>
      </div>

      <div className="category_cards">
        <img
          className="card_button"
          src={config.employmentContract}
          alt=""
          onClick={() => navigate("/employment-contract-templates")}
        />
        <img
          className="card_button"
          src={config.criminalcharges}
          alt=""
          onClick={() => navigate("/criminal-charges-templates")}
        />
        <img
          className="card_button"
          src={config.propertyOwnership}
          alt=""
          onClick={() => navigate("/property-ownership-templates")}
        />
        <img
          className="card_button"
          src={config.nonCriminalCertificate}
          alt=""
          onClick={() => navigate("/non-criminal-certificate-templates")}
        />
        <img
          className="card_button"
          src={config.leaseAgreement}
          alt=""
          onClick={() => navigate("/lease-agreement-templates")}
        />
        {[...Array(13)].map((_, i) => (
          <img
            key={i}
            className="card_button"
            src={config[`card_button${i + 1}`]}
            alt=""
            onClick={() => handleImageClick(`button${i + 1}`)}
          />
        ))}
      </div>

      {popupVisible && (
        <div className="popup_askabout">
          <div className="popup_content_askabout">
            <div className="popup_header_askabout">
              <span>Ask About</span>
              <button className="close_button_askabout" onClick={closePopup}>
                <img src={config.close_button_x} alt="" />
              </button>
            </div>
            <div className="popup_text_askabout">
              <div>{textLine1}</div>
              <p>{textLine2}</p>
            </div>
            <div className="popup_buttons_askabout">
              {buttonTexts.map((text, index) => (
                <button
                  key={index}
                  className="popup_button_askabout"
                  onClick={() => handleButtonClick(text, textLine1)}
                >
                  {text}
                </button>
              ))}
            </div>
            <div className="bottom_buttons_askabout">
              or{" "}
              <button
                className="askyourquestion"
                onClick={() => handleAskQueClick()}
              >
                Ask Your Own Question
              </button>
            </div>
          </div>
        </div>
      )}
      {viewAllPopupVisible && (
        <div className="popup_viewall">
          <div className="popup_content_viewall">
            <div className="popup_header_viewall">
              <span>All Categories</span>
              <button
                className="close_button_viewall"
                onClick={closeViewAllPopup}
              >
                <img src={config.close_button_x} alt="" />
              </button>
            </div>
            <div className="popup_images_viewall">
              <img
                className="popup_card_button"
                src={config.employmentContract}
                alt=""
                onClick={() => navigate("/employment-contract-templates")}
              />
              <img
                className="popup_card_button"
                src={config.criminalcharges}
                alt=""
                onClick={() => navigate("/criminal-charges-templates")}
              />
              <img
                className="popup_card_button"
                src={config.propertyOwnership}
                alt=""
                onClick={() => navigate("/property-ownership-templates")}
              />
              <img
                className="popup_card_button"
                src={config.nonCriminalCertificate}
                alt=""
                onClick={() => navigate("/non-criminal-certificate-templates")}
              />
              <img
                className="popup_card_button"
                src={config.leaseAgreement}
                alt=""
                onClick={() => navigate("/lease-agreement-templates")}
              />
              {[...Array(13)].map((_, i) => (
                <img
                  key={i}
                  className="popup_card_button"
                  src={config[`card_button${i + 1}`]}
                  alt=""
                  onClick={() => {
                    handleImageClick(`button${i + 1}`);
                    closeViewAllPopup();
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {popupaskque && (
        <div className="popup_askabout">
          <div className="popup_content_askabout">
            <div className="popup_header_askabout">
              <span>Ask About</span>
              <button
                className="close_button_askabout"
                onClick={closepopupaskque}
              >
                <img src={config.close_button_x} alt="" />
              </button>
            </div>
            <div className="popup_text_askabout">
              <div>Askyour own question</div>
            </div>

            <textarea
              className="Topic_askabout"
              id=""
              placeholder="Type your text here...."
              value={TopicValue}
              name="Topic"
              onChange={(e) => setTopicValue(e.target.value)}
              maxLength={1000}
            >
              {" "}
            </textarea>
            <div className="bottom_buttons_askabout">
              <button
                className="askyourquestion"
                onClick={() => handleButtonClick(TopicValue)}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Category;
